// src/pages/WelcomePage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import SeoMeta from '../../SEO/SeoMeta';

export default function WelcomePage() {
  return (
    <>
      <SeoMeta 
        title="Welcome — Million2Trillion (M2T)" 
        description="Thank you for joining Million2Trillion! Explore our financial market resources, blogs, and documentation while we prepare your dashboard."
        url="https://million2trillion.com/welcome"
      />

      <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center text-center p-6">
        <h1 className="text-3xl font-bold mb-4">🎉 Thank You for Signing Up Early!</h1>
        <p className="text-lg mb-6">
          We're building your personalized dashboard right now. 🚧
          In the meantime, feel free to explore:
        </p>
        <div className="space-x-4">
          <Link to="/blog" className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded text-white">Read Blogs</Link>
          <Link to="/documents" className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded text-white">View Docs</Link>
        </div>
      </div>
    </>
  );
}
